import { render, staticRenderFns } from "./CommisionConfig.vue?vue&type=template&id=07a9b2bb"
import script from "./CommisionConfig.vue?vue&type=script&lang=js"
export * from "./CommisionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports